
import './App.css';
import Main from './Main.jsx';
import {useState} from 'react';
function App() {
  const [isLoading] = useState(false);
  const images = [
    '/header_images/boss4.webp',
    '/header_images/lövurfokus.webp',
    '/header_images/husurfokus.webp',
    '/header_images/ravelights.webp',
  ];
  
  const getRandomImage = () => images[Math.floor(Math.random() * images.length)];
  const [currentImage] = useState(getRandomImage());
  const [bandImage] = useState("/header_images/bosslossless.webp");

  // useEffect(() => {
  //   const criticalImages = [currentImage, bandImage, '/logos/bossblack.png'];
  //   Promise.all(
  //     criticalImages.map(url => {
  //       return new Promise((resolve) => {
  //         const img = new Image();
  //         img.onload = img.onerror = resolve;
  //         img.src = url;
  //       });
  //     })
  //   ).then(() => {
  //     setIsLoading(false);
  //   });
  // }, [currentImage, bandImage]);
  if (isLoading) {
    return (
      <div className="App" style={{
        position:"relative",
        backgroundColor: 'white',
        background: 'linear-gradient(0deg, rgb(213, 210, 210) 0%, rgb(255, 255, 255) 40%, rgb(255, 255, 255) 100%)',
        height: '100vh',
        overflow: "hidden",
        }}>
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "15rem",
        height: "15rem",
        zIndex: 50,
        // borderRadius: "50%",
        backgroundImage: 'url("/logos/bosslogo.png")',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: "no-repeat",
        animation: "spinGradient 10s linear infinite"
      }} />
      </div>
    );
  }
  return (
    <div className="App" style={{
      backgroundColor: 'white',
      background: 'linear-gradient(0deg, rgb(213, 210, 210) 0%, rgb(255, 255, 255) 40%, rgb(255, 255, 255) 100%)',
    }}>
      <header>
        <Main image={currentImage} />
      </header>
      <div style={{ position: 'relative' }}>
        <div  className="container py-0 py-md-5 px-0 gap-5"
        style={{}}>
          <div className="row gap-5 mb-5">
            <div className="col-md-6 px-0">
              <div className="d-flex align-items-end h-100"
              style={{minHeight: "16rem"}}>
                <img src={bandImage} alt="Middle Boss" className="img-fluid" style={{ height: '100%', width: 'auto', objectFit: 'cover' }} />
              </div>
            </div>
            <div className="col-md-5 px-3 px-md-0 ">
              <div className="h-100 d-flex flex-column gap-5 ms-auto justify-content-between px-2 px-md-0">
                <div id="" className="d-flex flex-column gap-4 md-align-self-end"
                >
                  <h2 className="mb-0">
                    <a href="mailto:middlebossband@gmail.com" target="_blank" rel="noopener noreferrer">
                      <span>Contact {'->'}</span>
                    </a>
                  </h2>
                  <h2 className="mb-0"><a href="https://www.instagram.com/middlebossband/" target="_blank" rel="noopener noreferrer">Follow {'->'}</a></h2>
                  <h2 className="mb-0"><a href="https://open.spotify.com/artist/6NuDXDSuF3sgc4H1eSnziD" target="_blank" rel="noopener noreferrer">Listen {'->'}</a></h2>
                </div>
                  
                    <iframe title="Middle Boss Spotify" data-testid="embed-iframe" style={{borderRadius:"12px", verticalAlign: "bottom"}} src="https://open.spotify.com/embed/track/75UxitzGGucUParXvzXQ4i?utm_source=generator" width="100%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy">
                    </iframe>                  
                  

              </div>
            </div>
          </div>
          <div className="row d-md-none" >
            <div className="col-12">
              <div className="d-flex align-items-end" >
                <img src="/header_images/ljusurfokus.webp" alt="Middle Boss" className="img-fluid" style={{ width: '100%', height: '15rem', objectFit: 'cover' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ backgroundColor: '#19191A',   marginTop: '-1px' }}>
        <footer className="d-flex flex-column justify-content-end align-items-end p-3" style={{ minHeight: '18rem'}}>
          <small className="mb-0 text-muted text-small pe-2">:)</small>
        </footer>
      </div>
    </div>
  );
}

export default App;
